import { Form } from 'react-bootstrap';
import EpisodeDetailField from './EpisodeDetailField';
import {
  PatientEpisodeDetailsNames,
  type AdditionalSectionValue,
  type SectionField,
} from './types';
import PMMDocumentField from './pmmDocument/PMMDocumentField';
import type { CareProgressRowData } from '../../../Table/components/CareProgress/types';
import ScriptWrittenField from './pmmDocument/ScriptWrittenField';

interface AdditionalFieldProps {
  field: SectionField;
  value: AdditionalSectionValue;
  editProfile: boolean;
  onInputChange: (argu: any) => void;
}

const AdditionalField = ({
  field,
  value,
  editProfile,
  onInputChange,
}: AdditionalFieldProps) => {
  const renderField = () => {
    switch (field.formatType) {
      case 'pmm_document':
      case 'med_profile':
        const data = value.value as CareProgressRowData[];
        return (
          <PMMDocumentField
            data={data}
            name={field.title}
            id={`${field.key}+${field.title}`}
          />
        );
      case 'script_written':
        return (
          <ScriptWrittenField
            scriptWrittenValue={value.value as CareProgressRowData[]}
          />
        );
      case 'episode_detail':
        const label = field.title;
        return (
          <EpisodeDetailField
            label={label}
            value={value}
            italic={field.title === PatientEpisodeDetailsNames.PrevAdmission}
            editable={editProfile || field.editable}
          />
        );
      default:
        return <Form.Label className="labelSimple">-</Form.Label>;
    }
  };

  return renderField();
};

export default AdditionalField;
